import { SiweMessage } from "siwe";

const API_ENDPOINT = process.env.API_BASE_URL;
    
    
    export const getNonce =  async ( ) => {
      const res = await fetch(`${API_ENDPOINT}/auth/siwe/nonce`);
      const text = await res.text();
      return text as string;
    }
    export const createMessage = (nonce: string, address: string, chainId: number) =>
      new SiweMessage({
        domain: window.location.host,
        address: address,
        statement: "Sign in with Ethereum to the app.",
        uri: window.location.origin,
        version: "1",
        chainId: chainId,
        nonce,
      })
     export const getMessageBody = (message: SiweMessage) => message.prepareMessage();
     export const verify = async (message: string, signature: string): Promise<string> => {
       const res = await fetch(`${API_ENDPOINT}/auth/siwe/verify`, {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({ message, signature }),
       });
       if (!res.ok) throw new Error("Verification failed");
       const { token } = await res.json();
       return token as string;
     };
